import { useStrings } from "@1js/localization-components";
import {
  Body1,
  Image,
  makeStyles,
  Subtitle1,
} from "@fluentui/react-components";
import React from "react";
import {
  NoSearchResultHeading,
  NoSearchResultSubHeading,
} from "./SearchedPrompts.strings";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "90px",
    gap: "9px",
  },
});

export const NoSearchResults: React.FC = () => {
  const styles = useStyles();
  const localizations = useStrings({
    NoSearchResultHeading,
    NoSearchResultSubHeading,
  });

  return (
    <div className={styles.root}>
      <Image
        src="https://copilot.cloud.microsoft/images/0175-search-questionmark-d-standard-128x128.webp"
        aria-labelledby="no-results-heading"
      />
      <Subtitle1 id="no-results-heading">
        {localizations.NoSearchResultHeading()}
      </Subtitle1>
      <Body1>{localizations.NoSearchResultSubHeading()}</Body1>
    </div>
  );
};
